module.exports = "button {\n  line-height: 0.9rem; }\n\n:host /deep/ .list {\n  margin-top: 0; }\n"